<template>
  <span>
    <span v-show="$store.getters['app/overlays'].show_start_selector_overlay">
      <img class="background_image" src="./../assets/images/Asset 37.png" alt="">
      <img draggable="false" class="clickable" id="quit_btn_top" @click="goToHome()" src="./../assets/images/Asset 29.png" alt="">

      <span id="top_text">Waar geloof jij in?</span>

      <div>
        <!-- <img draggable="false" class="clickable" id="img_1" src="./../assets/images/Asset 39.png" alt="">
        <span id="text_1">Atheisme</span>
        <img draggable="false" class="clickable" id="img_2" src="./../assets/images/Asset 40.png" alt="">
        <span id="text_2">Islam</span>
        <img draggable="false" class="clickable" id="img_3" src="./../assets/images/Asset 45.png" alt="">
        <span id="text_3">Jodendom</span>
        <img draggable="false" class="clickable" id="img_4" src="./../assets/images/Asset 43.png" alt="">
        <span id="text_4">Christendom</span>
        <img draggable="false" class="clickable" id="img_5" src="./../assets/images/Asset 38.png" alt="">
        <span id="text_5">Jodendom</span>
        <img draggable="false" class="clickable" id="img_6" src="./../assets/images/Asset 41.png" alt="">
        <span id="text_6">Winti</span>
        <img draggable="false" class="clickable" id="img_7" src="./../assets/images/Asset 42.png" alt="">
        <span id="text_7">Hindoeisme</span> -->
      </div>

      <span id="bottom_text">Klik op een vakje voor meer info</span>
    </span>
  </span>
</template>

<script>
export default {
  name: "Start",
  mounted() {},

  created() {},
  destroyed() {},

  data() {
    return {};
  },

  methods: {
    goToHome() {
      this.$router.push('/');
      this.$store.dispatch('app/asyncUpdateOverlay', {
          show_start_menu_overlay: true,
          show_start_selector_overlay: false,
      });
    },
    goToGamePage() {
      this.$router.push('/game');
    },
    GoToPhagwaGame() {
      this.$router.push('/phagwagame');
    },
    GoToKerstmisGame() {
      this.$router.push('/kerstmisgame');
    },
  },

  computed: {}
};
</script>

<style>
  #top_text {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 5%;
    width: 40%;
    left: 30%;
    color: white;
    font-size: 4vw;
    text-align: center;
  }

  #bottom_text {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 45%;
    width: 70%;
    left: 15%;
    color: white;
    font-size: 4vw;
    text-align: center;
  }

  #quit_btn_top {
    position: absolute;
    top: 5%;
    right: 3%;
    width: 15%;
    z-index: 1;
  }

  #img_1 {
    position: absolute;
    top: 36%;
    left: 3%;
    width: 11%;
    height: auto;
  }
  #text_1 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 35.8%;
    width: 5%;
    left: 4%;
    color: #2372ff;
    font-size: 2vw;
    text-align: center;
  }

  #img_2 {
    position: absolute;
    top: 36%;
    left: 16%;
    width: 11%;
    height: auto;
  }
  #text_2 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 35.8%;
    width: 5%;
    left: 18.7%;
    color: #2372ff;
    font-size: 2vw;
    text-align: center;
  }

  #img_3 {
    position: absolute;
    top: 36%;
    left: 29%;
    width: 11%;
    height: auto;
  }
  #text_3 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 35.8%;
    width: 5%;
    left: 29.4%;
    color: #2372ff;
    font-size: 2vw;
    text-align: center;
  }

  #img_4 {
    position: absolute;
    top: 36%;
    left: 42.3%;
    width: 11.2%;
    height: auto;
  }
  #text_4 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 35.8%;
    width: 5.5%;
    left: 41.4%;
    color: #2372ff;
    font-size: 2vw;
    text-align: center;
  }

  #img_5 {
    position: absolute;
    top: 36%;
    left: 55.5%;
    width: 11%;
    height: auto;
  }
  #text_5 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 35.8%;
    width: 5%;
    left: 55.5%;
    color: #2372ff;
    font-size: 2vw;
    text-align: center;
  }

  #img_6 {
    position: absolute;
    top: 34%;
    left: 67%;
    width: 14.2%;
    height: auto;
  }
  #text_6 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 35.8%;
    width: 5%;
    left: 71%;
    color: #2372ff;
    font-size: 2vw;
    text-align: center;
  }

  #img_7 {
    position: absolute;
    top: 36%;
    left: 81.5%;
    width: 11%;
    height: auto;
  }
  #text_7 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 35.8%;
    width: 5%;
    left: 81.5%;
    color: #2372ff;
    font-size: 2vw;
    text-align: center;
  }

  #table {
    position: absolute;
    top: 75%;
    left: 28%;
    width: 45%;
    height: auto;
  }
</style>


